export const MESSAGE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'code',
];

export const MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'imageUpload',
];

export const ARTICLE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'h1',
  'h2',
  'h3',
  'imageUpload',
  'code',
];

export const WIDGET_BUILDER_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
];

export const MESSAGE_EDITOR_IMAGE_RESIZES = [
  {
    name: 'Small',
    i18nKey: 'CONVERSATION.REPLYBOX.IMAGE_SIZES.SMALL',
    height: '24px',
  },
  {
    name: 'Medium',
    i18nKey: 'CONVERSATION.REPLYBOX.IMAGE_SIZES.MEDIUM',
    height: '48px',
  },
  {
    name: 'Large',
    i18nKey: 'CONVERSATION.REPLYBOX.IMAGE_SIZES.LARGE',
    height: '72px',
  },
  {
    name: 'Original Size',
    i18nKey: 'CONVERSATION.REPLYBOX.IMAGE_SIZES.ORIGINAL_SIZE',
    height: 'auto',
  },
];
